/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from 'react';
import PropTypes from 'prop-types';
import './AwarenessPageStyles.css';

function CartAmountHeader({ totalAmount, goBack, showCartAmount = true }) {
  return (
    <div className="awareness-content">
      <img
        src="/chevron.svg"
        alt="chevron-icon"
        className="chevron-lto"
        onClick={goBack}
      />
      <img
        src="/snap-leasing.svg"
        alt="snap-leasing-icon"
        className="lto-align-center"
      />
      {showCartAmount && (
        <div className="cart-amount">
          <div className="cart-amount-container">
            <span className="cart-name-label">Cart Amount</span>&nbsp;
            <span className="cart-amount-label">${totalAmount}</span>
            <span>
              <img
                src="/help_outlined.svg"
                alt="help-icon"
                width="11%"
                title="Total amount"
                style={{ marginTop: 2, marginLeft: 2, cursor: 'pointer' }}
              />
            </span>
          </div>
        </div>
      )}
    </div>
  );
}

CartAmountHeader.propTypes = {
  totalAmount: PropTypes.string.isRequired,
  goBack: PropTypes.func.isRequired,
  showCartAmount: PropTypes.bool.isRequired
};

export default CartAmountHeader;
